import { useCallback, useEffect, useState } from "react"
import debounce from 'lodash.debounce'

export const useDebounce = (editRecordFunction) => {

    const [value, setValue] = useState('')

    const debouncedSave = useCallback(
        debounce((newValue, field) => {
            if (field) {
              editRecordFunction(newValue, field);
            } else {
              editRecordFunction(newValue);
            }
          }, 1500),
        [editRecordFunction]
    );

    const handleChange = (newValue) => {
        setValue(newValue);
        debouncedSave(newValue);
    };

    const handleChangeWithField = (newValue, field) => {
        setValue(newValue);
        debouncedSave(newValue, field);
      };

    useEffect(() => {
        return () => {
            debouncedSave.cancel();
        };
    }, [debouncedSave]);

    return {value, setValue, handleChange, handleChangeWithField}

}